export type PlayerErrorCode =
  | 'WS_CONNECTION_FAILED'
  | 'WS_DISCONNECTED'
  | 'AUTH_FAILED'
  | 'JOIN_FAILED'
  | 'JOIN_REJECTED'
  | 'SDP_NEGOTIATION_FAILED'
  | 'ICE_CONNECTION_FAILED'
  | 'MEDIA_TIMEOUT'
  | 'CASTROOM_CLOSED'

interface ErrorInfo {
  message: string
  canRetry: boolean
}

export const PLAYER_ERROR_MAP: Record<PlayerErrorCode, ErrorInfo> = {
  WS_CONNECTION_FAILED: {
    message: '서버에 연결할 수 없습니다. 네트워크 상태를 확인해주세요.',
    canRetry: true,
  },
  WS_DISCONNECTED: {
    message: '서버와의 연결이 끊겼습니다.',
    canRetry: true,
  },
  AUTH_FAILED: {
    message: '인증에 실패했습니다. API Key를 확인해주세요.',
    canRetry: false,
  },
  JOIN_FAILED: {
    message: '캐스트룸에 참여할 수 없습니다. 잠시 후 다시 시도해주세요.',
    canRetry: true,
  },
  JOIN_REJECTED: {
    message: '요청한 캐스트룸이 존재하지 않습니다.',
    canRetry: false,
  },
  SDP_NEGOTIATION_FAILED: {
    message: '영상 연결 협상에 실패했습니다. 잠시 후 다시 시도해주세요.',
    canRetry: true,
  },
  ICE_CONNECTION_FAILED: {
    message: '영상 수신 연결에 실패했습니다. 네트워크를 확인해주세요.',
    canRetry: true,
  },
  MEDIA_TIMEOUT: {
    message: '영상 수신 시간이 초과되었습니다.',
    canRetry: true,
  },
  CASTROOM_CLOSED: {
    message: '송출이 종료되었습니다.',
    canRetry: false,
  },
}

export function getErrorInfo(code: PlayerErrorCode): ErrorInfo {
  return PLAYER_ERROR_MAP[code] || { message: '알 수 없는 오류가 발생했습니다.', canRetry: true }
}

export type ConnectionState = 'idle' | 'connecting' | 'joining' | 'subscribing' | 'buffering' | 'playing' | 'error' | 'stopped'

export type StopReason = 'user' | 'server' | 'error'
